import { useTranslation } from 'react-i18next'

import { CaretRightIcon, WarningIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Chip, FormatNumber, Text } from '@reveni-io/reveni-ui'

import SizingIssuesTooltip from '../SizingIssuesTooltip/SizingIssuesTooltip'
import SizingTooltip from '../SizingIssuesTooltip/SizingTooltip/SizingTooltip'
import * as Styles from './styles'

const ProductType = ({
  productType,
  onClick,
  showAmounts = true,
  salesOrdersDataActivated,
  sizeRecommendationsActivated = false,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  return (
    <Styles.Container onClick={onClick}>
      <Styles.SideContainer>
        <Text type="bodyMRegular" color={theme.colors.text.subtle} customStyles={{ minWidth: '20px' }}>
          #{productType?.index}
        </Text>
        <Styles.NameAndProductsContainer>
          <Text type="titleS">{productType?.name || t('Sin Categoría')}</Text>
          <Text type="allCapsS">
            <FormatNumber style="decimal">{productType?.product_count}</FormatNumber>{' '}
            {productType?.product_count > 1 ? t('productos') : t('producto')}
          </Text>
          {sizeRecommendationsActivated && productType?.has_size_recommendation && (
            <SizingTooltip
              title={
                <SizingIssuesTooltip
                  recommendation={productType?.recommendation}
                  recommendationGlobal={productType?.recommendation_global}
                />
              }
            >
              <Styles.ChipWrapper>
                <Chip
                  label={t('Problemas de talla')}
                  Icon={WarningIcon}
                  backgroundColor={theme.colors.warning.surface}
                  color={theme.colors.warning.onSurface}
                />
              </Styles.ChipWrapper>
            </SizingTooltip>
          )}
        </Styles.NameAndProductsContainer>
      </Styles.SideContainer>
      {showAmounts && (
        <Styles.SideContainer>
          {salesOrdersDataActivated && (
            <Styles.Total type="bodyMRegular">
              <FormatNumber style="decimal">{productType?.sales}</FormatNumber>
            </Styles.Total>
          )}
          <Styles.Total type="bodyMRegular">
            <FormatNumber style="decimal">{productType?.count}</FormatNumber>
          </Styles.Total>
          <Styles.Total type="bodyMRegular">
            <FormatNumber style="percent">{productType?.percentage}</FormatNumber>
          </Styles.Total>
          <Styles.NavigationContainer>
            {typeof onClick === 'function' && <CaretRightIcon size={24} />}
          </Styles.NavigationContainer>
        </Styles.SideContainer>
      )}
    </Styles.Container>
  )
}

export default ProductType
